/**
 * User-facing booking type labels.
 *
 * Kept in one place so that every view (booking list, details view, ...) derives and
 * names the booking type identically. The wording mirrors the server-side labels in
 * RoomBookingWalkInApiController.
 */
export const BOOKING_TYPE_LABEL_WALK_IN = 'Sofortbuchung';
export const BOOKING_TYPE_LABEL_WITHOUT_POINTS = 'Buchung ohne Punkte';
export const BOOKING_TYPE_LABEL_WITH_POINTS = 'Punktebuchung';

/**
 * Derives the booking type of a hydrated booking.
 *
 * Order matters: a walk-in booking never carries a points transaction, so it has to be
 * recognised before the "without points" case.
 *
 * @param {Object} booking - Hydrated booking as returned by the API
 * @returns {string} One of the BOOKING_TYPE_LABEL_* constants
 */
export function getBookingTypeLabel(booking) {
	if (booking?.walkIn) {
		return BOOKING_TYPE_LABEL_WALK_IN;
	}
	if (!booking?.points) {
		return BOOKING_TYPE_LABEL_WITHOUT_POINTS;
	}
	return BOOKING_TYPE_LABEL_WITH_POINTS;
}
